import React from "react";
import { FaRegCalendarAlt, FaCheckCircle, FaTimesCircle, FaHashtag } from "react-icons/fa";

const CategoryViewData = ({ category }) => {
  if (!category) return null;

  const formatValue = (key, value) => {
    if (key === "status") return value === 1 ? "Active" : "Inactive";
    if (key === "is_deleted") return value ? "Yes" : "No";
    if (["createdAt", "updatedAt"].includes(key) && value) return new Date(value).toLocaleString();
    return value || "-";
  };

  const getIcon = (key, value) => {
    switch (key) {
      case "status":
        return value === 1 ? <FaCheckCircle className="text-green-500" /> : <FaTimesCircle className="text-red-500" />;
      case "createdAt":
      case "updatedAt":
        return <FaRegCalendarAlt className="text-gray-400" />;
      case "id":
        return <FaHashtag className="text-gray-500" />;
      default:
        return null;
    }
  };

  // Fields grouping
  const mainFields = ["id", "category", "suggested_category"];
  const statusFields = ["status", "is_deleted"];
  const dateFields = ["createdAt", "updatedAt"];

  const renderField = (key) => (
    <div
      key={key}
      className="flex items-center justify-between  p-3 rounded-lg shadow hover:shadow-md transition"
    >
      <div className="flex items-center gap-2">
        {getIcon(key, category[key])}
        <span className="font-semibold text-gray-700">{key.replace(/_/g, " ").toUpperCase()}</span>
      </div>
      <span
        className={`font-medium ${
          key === "status"
            ? category[key] === 1
              ? "text-green-600"
              : "text-red-600"
            : "text-gray-800"
        }`}
      >
        {formatValue(key, category[key])}
      </span>
    </div>
  );

  return (
    <div className="max-w-lg mx-auto bg-gray-50 shadow-xl rounded-2xl p-6 ">
      <div className="space-y-4">
        {/* Main Info */}
        <div className="space-y-2">
          {mainFields.map(renderField)}
        </div>

        {/* Status Info */}
        <div className="space-y-2">
          {statusFields.map(renderField)}
        </div>

        {/* Dates */}
        <div className="space-y-2">
          {dateFields.map(renderField)}
        </div>
      </div>
    </div>
  );
};

export default CategoryViewData;
